import { useTranslation } from 'react-i18next';

import { OrderFormCategoryDTO } from 'support/types/dtos';

import { OrderFormProduct } from '../OrderFormProduct/OrderFormProduct';

type OrderFormCategoryProps = {
  category: OrderFormCategoryDTO;
};

export const OrderFormCategory = ({ category }: OrderFormCategoryProps) => {
  const { t } = useTranslation();

  return (
    <section className="mt-21" id={category.name} style={{ scrollMarginTop: 'var(--order-form-header-height)' }}>
      <div className="sticky bg-white" style={{ top: 'var(--order-form-header-height)' }}>
        <div className="flex items-end justify-between border-b border-gray-200 pb-3">
          <h3 className="text-lg font-bold text-gray-900">{category.name}</h3>
          <span className="text-xs text-gray-500">
            {t('orderForms:form.category.itemCount', { count: category.products?.length || 0 })}
          </span>
        </div>
      </div>

      {category.products?.map((product) => (
        <OrderFormProduct key={product.id} product={product} />
      ))}
    </section>
  );
};
